/// This file was generated DO NOT MODIFY
/// Source: Status.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum StatusEnum {
  New = 'New', //0
  Waiting = 'Waiting', //1
  Approved = 'Approved', //2
  Refused = 'Refused', //3
  Imported = 'Imported', //4
  
}
